import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';

function ListingEnquiry() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [listing_enquiry, setListingEnquiry] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Client Listing Enquiry';
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/listing/enquiry`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setListingEnquiry(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className="card">
                            <div className="card-header fw-bold" style={{whiteSpace:'nowrap'}}>Listing Enquiry</div>
                            {/* <div className="card-body">  */}
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">User</th>
                                            <th scope="col">Listing</th>
                                            <th scope="col">Subject</th>
                                            <th scope="col">Message</th>
                                            <th scope="col">Submitted Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                        {listing_enquiry && listing_enquiry.length > 0 ? (
                                            listing_enquiry.map((data, i) => (
                                                <tr key={i}> 
                                                    <th scope="row">{i + 1}</th>
                                                    <td>
                                                        <b>{data.user.name}</b>
                                                        <br />
                                                        +91 {data.user.phone}
                                                    </td>
                                                    <td>{data.listing.name}</td>
                                                    <td>{data.subject}</td>
                                                    <td>{data.message}</td>
                                                    <td>{format(data.created_at, 'dd MMM, yyyy')}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="6" className="text-center">No data available.</th>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> 
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default ListingEnquiry;           